/* eslint-disable @typescript-eslint/no-var-requires */
const i18nConfig = require("@sablier/v2-locales/src/i18n.base");

module.exports = i18nConfig;
